import { createApp } from 'vue';
import AvifToJpgConverter from '../Components/AvifToJpgConverter.vue';

const root = document.getElementById('avif-to-jpg-converter');
if (root) {
  createApp(AvifToJpgConverter).mount('#avif-to-jpg-converter');
}
